import React from 'react';
import './share.css';

const Share = () => {
    const [copied, setCopied] = React.useState(null)

    const onClick = () => {
        navigator.clipboard.writeText("https://maufcost.github.io/the-valley-musical-website/");

        setCopied(true);
        setTimeout(() => setCopied(null), 3000);
    }

	return (
        <div className="share-container">
            <div className="share m-auto">
                <h3 className="title" style={{ marginBottom: 10 }}><span className="add-bb">Share</span> with others!</h3>
                <br />
                <button onClick={onClick}>{copied ? "Copied! ✅" : "Copy link 👈"}</button>
            </div>
        </div>
    )
}

export default Share;
